import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    slide: 1,
    floor: null,
    loading: true,
    lang: 'sk',
  },
  getters: {
    getSlide: (state) => state.slide,
    getFloor: (state) => state.floor,
    getLoading: (state) => state.loading,
    getLang: (state) => state.lang,
  },
  mutations: {
    setSlide: (state, payload) => (state.slide = payload),
    setFloor: (state, payload) => (state.floor = payload),
    setLoading: (state, payload) => (state.loading = payload),
    setLang(state, lang) {
      state.lang = lang;
    },
  },
});
